import x from './CaruselHeader';

export default x;
